import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { CatalogCurrencyLabel } from 'Shared/CurrencyLabel'

const MobileRechargeScheduleInfo = props => (
  <div className='row product-brand pt-3  px-2'>
    <div className='col-12 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center '>
      <p className='txt-body-sm txt-subtitle txt-font-body color-ui-2'>
        Resgate agendado em:
        <strong>
          {moment(props.dateCreatedScheduling).format(
            'DD/MM/YYYY [às] HH[h]MM'
          )}
        </strong>
      </p>
      <p className='txt-body-sm txt-subtitle txt-font-body color-ui-2'>
        operadora: <strong>{props.operator}</strong>
      </p>
      <p className='txt-body-sm txt-subtitle txt-font-body color-ui-2'>
        Telefone: <strong>{props.phoneNumber}</strong>
      </p>
      <p className='txt-body-sm txt-subtitle txt-font-body color-ui-2'>
        Valor de créditos: <strong>R${props.creditValue}</strong>
      </p>
      <p className='txt-body-sm txt-subtitle txt-font-body color-ui-2'>
        Valor em reales:{' '}
        <strong>
          <CatalogCurrencyLabel value={props.pointValue} />
        </strong>
      </p>
    </div>
  </div>
)

MobileRechargeScheduleInfo.propTypes = {
  dateCreatedScheduling: PropTypes.objectOf(typeof date),
  operator: PropTypes.string,
  phoneNumber: PropTypes.string,
  creditValue: PropTypes.phoneNumber,
  pointValue: PropTypes.phoneNumber
}
export default MobileRechargeScheduleInfo



// WEBPACK FOOTER //
// ./src/features/ConfirmationMobileRechargeSchedule/AboutMobileRechargeSchedule/MobileRechargeScheduleInfo.js